/** Ordinary portal calls. Ceremony calls stay under the BFF's 20s upstream abort. */
export const REQUEST_TIMEOUT_MS = 15_000;
export const CEREMONY_TIMEOUT_MS = 25_000;

export function browserTimeoutMs(path: string): number {
  if (/\/auth\/(?:passkey|mfa|step-up\/passkey)\//.test(path) || /\/federation\//.test(path) || /\/mfa(?:\/|$)/.test(path)) return CEREMONY_TIMEOUT_MS;
  return REQUEST_TIMEOUT_MS;
}
